module.exports = __webpack_public_path__ + "img/kazaxstan-o.c97fe46d.jpg";